<template>
  <FullScreenMap v-slot="{ fullScreen }">
    <Box :aspect="0.4" class="map-container mb-15" :class="{ '!h-screen !w-screen': fullScreen }">
      <ShowBicycleLocationMap
        :points="points"
        :show-info="true"
        :hide-inner-circle="true"
      >
        <template #info="{ point }">
          <h6>{{ point.name }}</h6>
          {{ $t('pages.visibility.bicycle.map.infoWindowText') + point.name + " " + point.radius }}
        </template>
      </ShowBicycleLocationMap>
    </Box>
  </FullScreenMap>
</template>

<script lang="ts" setup>
import Box from '@utils/Box.vue';
import {
  computed,
} from 'vue';
import FullScreenMap from '@utils/FullScreenMap.vue';
import ShowBicycleLocationMap from '@utils/maps/ShowBicycleLocationMap.vue';
import type { EnrichedVisibilityBicycleDto } from '@/entities/Entities';

const props = withDefaults(defineProps<{
  points?: EnrichedVisibilityBicycleDto[];
}>(), {
  points: () => [],
});

const points = computed(() => {
  const newPoints = [];
  for (const p of (props.points)) {
    if (p.currentLocationForBicycle?.gisLocation) {
      newPoints.push({
        id: `${p.id}planned`,
        isTracker: false,
        gisLocation: p.currentLocationForBicycle.gisLocation,
        radius: 100,
        name: p.visibilityBicycle.name,
      });
    }

    const trackerPoint = p.visibilityTracker?.latestPoints?.reduce((max, pt) => (pt.accuracy > (max ?? -Infinity) ? pt : max), null);

    if (!trackerPoint) {
      // eslint-disable-next-line no-continue
      continue;
    }

    if (trackerPoint) {
      newPoints.push({
        id: `${p.id}tracker`,
        isTracker: true,
        gisLocation: {
          lat: trackerPoint.location.lat,
          long: trackerPoint.location.lng,
        },
        radius: trackerPoint.accuracy,
        name: p.visibilityBicycle.name,
      });
    }
  }
  return newPoints;
});
</script>
